/**
 * Truncate number to specified decimal places (without rounding)
 */
export function truncateToDecimals({
  value,
  decimals,
}: {
  value: number
  decimals: number
}): number {
  if (decimals <= 0) return Math.trunc(value)

  const multiplier = Math.pow(10, decimals)
  return Math.trunc(value * multiplier) / multiplier
}
